import Swiper from 'swiper';
import { Autoplay, Keyboard, A11y } from 'swiper/modules';

const init = () => {
    const sliders = document.querySelectorAll('.logo-swiper');
    
    if (sliders.length) {
        sliders.forEach(slider => {
            new Swiper(slider, {
                modules: [Autoplay, Keyboard, A11y],
                slidesPerView: 2,
                spaceBetween: 30,
                loop: true,
                speed: 1000,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                },
                keyboard: {
                    enabled: true,
                    onlyInViewport: true,
                },
                a11y: {
                    enabled: true,
                    prevSlideMessage: typeof nlTheme !== 'undefined' ? nlTheme?.slider?.logo?.prev : 'Previous logo',
                    nextSlideMessage: typeof nlTheme !== 'undefined' ? nlTheme?.slider?.logo?.next : 'Next logo',
                    firstSlideMessage: typeof nlTheme !== 'undefined' ? nlTheme?.slider?.logo?.first : 'This is the first logo',
                    lastSlideMessage: typeof nlTheme !== 'undefined' ? nlTheme?.slider?.logo?.last : 'This is the last logo',
                    paginationBulletMessage: typeof nlTheme !== 'undefined' ? nlTheme?.slider?.logo?.pagination : 'Go to logo {{index}}',
                    itemRoleDescriptionMessage: typeof nlTheme !== 'undefined' ? nlTheme?.slider?.logo?.item : 'logo',
                    containerMessage: typeof nlTheme !== 'undefined' ? nlTheme?.slider?.logo?.container : 'Logo Carousel',
                },
                breakpoints: {
                    500: {
                        slidesPerView: 3,
                    },
                    768: {
                        slidesPerView: 4,
                    },
                    1024: {
                        slidesPerView: 5,
                    },
                }
            });
        });
    }
};

export { init };
